import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=70137143&scoped=true"
import script from "./Lottie.vue?vue&type=script&lang=js"
export * from "./Lottie.vue?vue&type=script&lang=js"
import style0 from "./Lottie.vue?vue&type=style&index=0&id=70137143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70137143",
  null
  
)

export default component.exports